
import { useLanguage } from '@/hooks/useLanguage';

interface CVENoResultsProps {
  isSearching: boolean;
}

export function CVENoResults({ isSearching }: CVENoResultsProps) {
  const { t } = useLanguage();
  
  return (
    <div className="text-center py-10">
      <p className="text-muted-foreground">
        {isSearching 
          ? t('cve.noSearchResults') 
          : t('cve.noSearchResults')}
      </p>
    </div>
  );
}
